import { useContext, useEffect, useRef, useState } from 'react';
import './style.module.css';
import { checkOtp, sendOtp } from '@services/Api';
import { LoaderBtn } from '../loading/Loader';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '@context/createContext';
import ToastError from '../toast/ToastError';
import ToastSuccess from '../toast/ToastSuccess';
import { patternTelInput } from '@helper/functions';
import { setCookie } from '@helper/functions';

export default function CheckOtpForm({ modalLoginHandler, phone, setLoading, loading, formik, setFlow, setLoginStep }) {
  const [otp, setOtp] = useState(['', '', '', '', '']);
  const [checkOtpBorder, setCheckOtpBorder] = useState(null);
  const inputRefs = useRef([]);
  const [minutes, setMinutes] = useState(2);
  const [second, setSeconds] = useState(0);
  const [failOtpMessage, setFailOtpMessage] = useState('');
  const navigate = useNavigate();

  const { refetch } = useContext(UserContext);

  useEffect(() => {
    const countDown = setInterval(() => {
      if (minutes === 0 && second === 0) {
        clearInterval(countDown);
      } else if (second === 0) {
        setMinutes((prevMinutes) => prevMinutes - 1);
        setSeconds(59);
      } else {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }
    }, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(countDown);
  }, [minutes, second]);

  const handleChange = (element, index) => {
    const value = element.value;
    if (isNaN(value)) return false;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input if value is entered
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }

    // Move to previous input if value is deleted
    // if (!value && index > 0) {
    //   inputRefs.current[index - 1].focus();
    // }
  };
  useEffect(() => {
    if (otp[0] != '' && otp[1] != '' && otp[2] != '' && otp[3] != '' && otp[4] != '') {
      CheckOtpHandler();
      inputRefs.current[4].blur();
    }
  }, [otp]);
  const handleKeyDown = (e, index) => {
    if ((e.key === 'Backspace' || e.key === 'Delete') && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
    // Focus the first input on component mount
    inputRefs.current[0].focus();
  }, []);

  const CheckOtpHandler = () => {
    setLoading(true);
    const otpString = otp.join('');
    checkOtp(phone[0] == '0' ? phone : '0' + phone, otp.join(''))
      .then((res) => {
        if (res.status == 'success') {
          setCheckOtpBorder(true);
          setCookie('accessToken', res.data.accessToken, 1);
          setCookie('refreshToken', res.data.refreshToken, 14);
          setCookie('id', res.data.id, 1);

          res.data.loginStatus == false ? setFlow((prev) => ({ prev, step: 2 })) : refetch();

          modalLoginHandler();
          formik.resetForm();
        } else {
          setFailOtpMessage(res.message);
          setOtp(['', '', '', '', '']);
          setCheckOtpBorder(false);
          setTimeout(() => {
            setCheckOtpBorder(null);
            inputRefs.current[0].focus();
          }, 2000);
        }
      })
      .then(() => {})
      .catch((e) => {
        ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید.' });
      })
      .finally((e) => {
        setLoading(false);
      });
  };
  const resendOtp = () => {
    sendOtp(phone)
      .then((res) => {
        if (res.status == 'success') {
          setLoginStep(2);
          ToastSuccess({ content: 'کد یکبار مصرف برای شما ارسال شد' });
        } else {
          ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید.' });
        }
      })
      .catch((e) => {
        ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید.' });
      })
      .finally((e) => {
        setLoading(false);
      });
    setMinutes(2);
    setSeconds(0);
  };
  return (
    <div className="w-full max-w-[600px] h-fit bg-white z-[110] md:rounded-2xl rounded-none relative overflow-hidden">
      <div className="flex flex-col gap-12 items-center w-full relative py-12 px-2 md:px-20">
        {/* gradient */}
        {/* <span className=" flex items-center justify-center w-full h-[500px] top-24 blur-2xl opacity-70 scale-150 absolute">
          <span className="gradientLogin w-full h-full"></span>
        </span> */}
        {/* close */}
        {/* <button
          // onClick={(e) => {
          //   modalLoginHandler();
          //   formik.resetForm();
          // }}
          className="absolute p-1 flex items-center justify-center top-6 left-6 hover:bg-blackFont-100 rounded-full transition-all"
        >
          <span className="w-7 h-7 md:w-8 md:h-8 p-1">
            <img
              className="w-full h-full opacity-70"
              src="/assets/media/common/close-icon.svg"
             
            />
          </span>
        </button> */}
        {/* logo */}
        {/* <span className="w-12 h-12 md:w-16 md:h-16 p-2 flex items-center justify-center bg-primary rounded-full z-20">
          <img
            src="/assets/media/common/logo2-white.svg"
            className="w-[30px] lg:w-[50px]"
          />
        </span> */}

        {/* title */}
        <div className="flex flex-col items-center gap-2 z-10">
          <span className="text-[22px] font-bold">کد تایید را وارد کنید</span>
          <span className="text-[17px] font-[400] text-blackFont-600">
            کد ۵ رقمی به شماره <span className="font-medium">{phone}</span>
            ارسال شد
          </span>
        </div>
        {/* input */}
        <div className="flex flex-col w-full gap-3 z-10">
          <button
            onClick={() => {
              setLoginStep(1);
              setLoading(false);
            }}
            disabled={loading}
            dir="rtl"
            className="hover:bg-primary/10 transition-all py-1 px-2 rounded-xl text-primary text-[14px] cursor-pointer flex items-center gap-2 w-fit"
          >
            <img className="w-4" src="/svg/edit-2.svg" alt="edit" />
            <span>ویرایش شماره موبایل</span>
          </button>
          <div dir="ltr" className="flex items-center justify-between gap-2 md:gap-5 w-full relative">
            {otp.map((data, index) => (
              <label
                key={index}
                htmlFor={`otp-${index}`}
                className={`rounded-lg border-[1.5px] ${
                  checkOtpBorder ? 'border-success' : checkOtpBorder === false ? 'border-error' : 'border-blackFont-300'
                } w-full h-[50px] has-[:focus]:border-blackFont-900 overflow-hidden transition-all p-1 flex items-center justify-center`}
              >
                <input
                  // autoFocus={`otp-${1}`}
                  id={`otp-${index}`}
                  name={`otp-${index}`}
                  dir="ltr"
                  maxLength={1}
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  onFocus={(e) => e.target.select()}
                  ref={(el) => (inputRefs.current[index] = el)}
                  onInput={patternTelInput}
                  className="p-2 text-center w-full h-full bg-transparent text-[18px] placeholder:text-blackFont-300"
                  type="tel"
                />
              </label>
            ))}
            <span
              className={`text-[12px] text-error absolute -bottom-[22px] right-0 transition-all whitespace-nowrap w-full ${
                checkOtpBorder === false ? 'visible opacity-100' : 'invisible opacity-0'
              }`}
            >
              {failOtpMessage.split('(')[0]}
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-3 w-full z-10">
          <div className="flex items-center justify-center w-full">
            {second == 0 && minutes == 0 ? (
              <span
                onClick={resendOtp}
                className="hover:bg-primary/10 transition-all py-1 px-2 rounded-xl text-primary text-[14px] cursor-pointer"
              >
                ارسال مجدد کد پیامکی
              </span>
            ) : (
              <span className="text-[13px] text-blackFont-500">
                0{minutes}:{second} تا درخواست مجدد کد
              </span>
            )}
          </div>
          <button
            onClick={CheckOtpHandler}
            disabled={loading}
            className="bg-primary disabled:cursor-not-allowed disabled:bg-blackFont-300 w-full h-[48px] flex items-center justify-center text-white rounded-lg"
          >
            {loading ? <LoaderBtn /> : 'تایید و ادامه'}
          </button>
        </div>
      </div>
    </div>
  );
}
